import { render, staticRenderFns } from "./_base-email-picker.vue?vue&type=template&id=4cfed78c&scoped=true&"
import script from "./_base-email-picker.vue?vue&type=script&lang=js&"
export * from "./_base-email-picker.vue?vue&type=script&lang=js&"
import style0 from "./_base-email-picker.vue?vue&type=style&index=0&id=4cfed78c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cfed78c",
  null
  
)

export default component.exports